export default __webpack_public_path__ + "static/blob13-15e52a60f88177955dbfd62d2ed66b4d.svg";